import { render, staticRenderFns } from "./DraggableList.vue?vue&type=template&id=b49d3d32&scoped=true&"
import script from "./DraggableList.vue?vue&type=script&lang=js&"
export * from "./DraggableList.vue?vue&type=script&lang=js&"
import style0 from "./DraggableList.vue?vue&type=style&index=0&id=b49d3d32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49d3d32",
  null
  
)

export default component.exports